import * as actionTypes from 'constants/ActionTypes';

export function getCargoesByTypeName(filter) {
    return {
        type: actionTypes.GET_CARGOES_BY_TYPE_NAME.REQUEST,
        filter,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/names.js